import axios from 'axios';
import toast from 'react-hot-toast';

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    (config) => {
        const authHeader = config.headers?.Authorization || config.headers?.authorization;
        if (authHeader === 'Bearer null' || authHeader === 'Bearer undefined') {
            delete config.headers.Authorization;
            delete config.headers.authorization;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            if (!error.config?.url?.includes('/auth/status') && window.location.pathname !== '/login') {
                toast.error('Session expired. Please login again.');
                window.location.href = '/login';
            }
        }

        if (error.response?.status === 403 && !error.config?.url?.includes('/auth/status')) {
            // Suppress toast for business-logic 403s on interview routes
            // (disqualified, completed) — handled by the Quiz component's catch block.
            const isInterviewRoute =
                error.config?.url?.includes('/interviews/start-test') ||
                error.config?.url?.includes('/interviews/submit-test') ||
                error.config?.url?.includes('/interviews/questions');
            if (!isInterviewRoute) {
                toast.error(error.response?.data?.message || 'You do not have access to perform this action.');
            }
        }

        return Promise.reject(error);
    }
);

export default axios;
